import Vue from 'vue'
import get from 'lodash/get'
import rolebleMixin from '@/mixins/rolebleMixin'
import ChatRoom from '@/models-ts/chat/ChatRoom'
import UserBannedChatMessage from '@/models-ts/chat/messages/UserBannedChatMessage'
import messageMixin from '../messageMixin'

export default Vue.extend<any, any, any, any>({
  mixins: [messageMixin, rolebleMixin],
  props: {
    message: UserBannedChatMessage,
    room: ChatRoom,
  },
  computed: {
    participantName() {
      const res = this.message.body.message.match(/\s* (.*) is banned/)
      return get(res, '[1]', '')
    },
  },
})
